import React from "react";
import logo from "../../assets/images/logo_black.png";
import coatOfArms from "../../assets/images/coat_of_arms.png";
import "./TopBar.css";
import { useSelector } from "react-redux";

const TopBar = () => {
  const { activeSession } = useSelector(({ auth }) => auth);

  return (
    <div className="top-bar">
      <div className="logo">
        <img src={logo} alt="BOT" />
      </div>
      <div className="header">
        <div className="flex-row justify-content-center" id="user-info">
          <div className="ml-5 mr-5" style={{ color: "#f5f5f5" }}>
            |
          </div>
          <div>{activeSession?.FULL_NAME}</div>
          <div className="ml-5 mr-5" style={{ color: "#f5f5f5" }}>
            |
          </div>
          <div>{activeSession?.ROLE_NAME}</div>
          <div className="ml-5 mr-5" style={{ color: "#f5f5f5" }}>
            |
          </div>
        </div>
        <div id="system-name">FinTech Regulatory Sandbox Portal</div>
      </div>
      <div className="logo-right">
        <img src={coatOfArms} alt="BOT" />
      </div>
    </div>
  );
};

export default TopBar;
